<template>
  <div class="route-list-wrapper">
    <Table
      ref="tableRef"
      :params="tableParams"
      :request="getData"
      tooltip-effect="light"
    >
      <template #search="{ query }">
        <el-form-item>
          <el-button icon="el-icon-plus" type="danger" @click="handleAddRoute">
            {{ $t('smartRouting.mapCenter.pathPlanning.routeManagement.addRoute') }}
          </el-button>
        </el-form-item>
      </template>

      <el-table-column prop="code" :label="$t('smartRouting.mapCenter.pathPlanning.routeId')" min-width="140" />
      <el-table-column prop="name" :label="$t('smartRouting.mapCenter.pathPlanning.routeManagement.routeName')" min-width="160" />
      <el-table-column prop="robotNames" :label="$t('smartRouting.mapCenter.pathPlanning.associateRobot')" min-width="140" />
      <el-table-column prop="createBy" :label="$t('smartRouting.mapCenter.creator')" min-width="120" />
      <el-table-column prop="createTime" :label="$t('smartRouting.mapCenter.createdAt')" min-width="160" />
      <el-table-column prop="updateBy" :label="$t('smartRouting.mapCenter.updater')" min-width="120" />
      <el-table-column prop="updateTime" :label="$t('smartRouting.mapCenter.updatedAt')" min-width="160" />
      <el-table-column :label="$t('smartRouting.mapCenter.pathPlanning.routeManagement.operation')" width="150" fixed="right">
        <template #default="{ row }">
          <el-tooltip :content="$t('smartRouting.mapCenter.detail')" placement="top">
            <el-button type="text" size="small" icon="el-icon-view" @click="openDetailDialog(row)">
              <!-- {{ $t('smartRouting.mapCenter.detail') }} -->
            </el-button>
          </el-tooltip>
          <el-tooltip :content="$t('smartRouting.mapCenter.edit')" placement="top">
            <el-button type="text" size="small" icon="el-icon-edit" @click="handleEdit(row)">
              <!-- {{ $t('smartRouting.mapCenter.edit') }} -->
            </el-button>
          </el-tooltip>
          <el-tooltip :content="$t('smartRouting.mapCenter.pathPlanning.routeManagement.deliver')" placement="top">
            <el-button type="text" size="small" icon="el-icon-position" @click="openDeliverDialog(row)">
              <!-- {{ $t('smartRouting.mapCenter.pathPlanning.routeManagement.deliver') }} -->
            </el-button>
          </el-tooltip>
          <el-tooltip :content="$t('smartRouting.mapCenter.delete')" placement="top">
            <el-button type="text" style="color: red;" size="small" icon="el-icon-delete" @click="handleDelete(row)">
              <!-- {{ $t('smartRouting.mapCenter.delete') }} -->
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </Table>

    <!-- ========== 下发三步向导弹窗（步骤1/2/3） ========== -->
    <el-dialog
      v-model="deliverDialogVisible"
      :title="$t('smartRouting.mapCenter.pathPlanning.routePackageDelivery.title')"
      width="960px"
      :close-on-click-modal="false"
      class="deliver-dialog"
      @close="handleDeliverDialogClose"
    >
      <!-- 步骤条 -->
      <el-steps :active="currentStep" finish-status="success" align-center class="deliver-steps">
        <el-step :title="$t('smartRouting.mapCenter.pathPlanning.routePackageDelivery.step1')" />
        <el-step :title="$t('smartRouting.mapCenter.pathPlanning.routePackageDelivery.step2')" />
        <el-step :title="$t('smartRouting.mapCenter.pathPlanning.routePackageDelivery.step3')" />
      </el-steps>

      <!-- ===== 步骤1: 选择目标设备 ===== -->
      <div v-show="currentStep === 0" class="step-content">
        <div class="step-hint">
          <i class="el-icon-info"></i>
          {{ $t('smartRouting.mapCenter.pathPlanning.routePackageDelivery.wizardHint', { routeName: deliverData.name || '' }) }}
        </div>

        <div class="strategy-section">
          <span class="strategy-label">{{ $t('smartRouting.mapCenter.pathPlanning.routePackageDelivery.deliveryStrategy') }}</span>
          <el-radio-group v-model="deliverData.strategy" size="small">
            <el-radio-button label="FULL">{{$t('smartRouting.mapCenter.pathPlanning.routePackageDelivery.strategyFull')}}</el-radio-button>
            <!-- <el-radio-button disabled label="GRAY">{{$t('smartRouting.mapCenter.pathPlanning.routePackageDelivery.strategyGray')}}</el-radio-button>
            <el-radio-button disabled label="INCR">{{$t('smartRouting.mapCenter.pathPlanning.routePackageDelivery.strategyIncremental')}}</el-radio-button> -->
          </el-radio-group>
        </div>

        <div class="strategy-section">
          <span class="strategy-label">{{$t('smartRouting.deliver.targetDevice') }}</span>
          <span class="device-count">
            {{ $t('smartRouting.deliver.deviceCount', {
              selected: selectedDevices?.length || 0,
              total: deviceList?.length || 0
            }) }}
            <span v-if="excludedCount">
              {{ $t('smartRouting.deliver.deviceCountFault', { fault: excludedCount }) }}
            </span>
            {{ $t('smartRouting.deliver.deviceCountEnd') }}
          </span>
        </div>

        <!-- 目标设备 - 从接口获取 -->
        <div class="device-section">
          <el-table :data="deviceList" class="device-table" max-height="260" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="40" />
            <el-table-column prop="deviceCode" label="SN" />
            <el-table-column prop="deviceName" :label="$t('smartRouting.mapCenter.pathPlanning.routePackageDelivery.deviceName')" />
            <el-table-column prop="deviceModel" :label="$t('smartRouting.mapCenter.pathPlanning.routePackageDelivery.deviceModel')" />
            <el-table-column prop="isOnline" :label="$t('smartRouting.mapCenter.pathPlanning.routePackageDelivery.deviceStatus')">
              <template #default="{ row }">
                <span class="status-dot" :class="row.isOnline"></span>
                <span :class="row.isOnline ? 'text-success' : 'text-danger'">
                  {{ row.isOnline
                    ? $t('smartRouting.mapCenter.pathPlanning.routePackageDelivery.online')
                    : $t('smartRouting.mapCenter.pathPlanning.routePackageDelivery.offline')
                  }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="step-footer">
          <el-button @click="handleDeliverDialogClose">{{ $t('smartRouting.mapCenter.pathPlanning.routePackageDelivery.cancel') }}</el-button>
          <el-button :disabled="(selectedDevices?.length || 0) === 0" type="danger" @click="handleNextStep" :loading="step1Loading">
            {{ $t('smartRouting.mapCenter.pathPlanning.routePackageDelivery.next') }}
          </el-button>
        </div>
      </div>

      <!-- ===== 步骤2: 部署预检 ===== -->
      <div v-show="currentStep === 1" class="step-content">
        <div class="precheck-title">
          {{ $t('smartRouting.mapCenter.pathPlanning.deploymentPrecheck.precheckTitle', {
            routeName: deliverData.name || '',
            count: selectedDevices.length
          }) }}
        </div>
        <!-- 预检项 -->
        <div class="precheck-list">
          <div class="precheck-item">
            <div class="precheck-left">
              <span class="precheck-icon" :class="{
                'icon-pass': onlineDevices.length > 0,
                'icon-fail': onlineDevices.length == 0
              }">
                <i v-if="onlineDevices.length > 0" class="el-icon-circle-check"></i>
                <i v-else class="el-icon-circle-close"></i>
              </span>
              <span class="precheck-label"> {{ $t('smartRouting.mapCenter.pathPlanning.deploymentPrecheck.deviceOnlineLabel') }} </span>
            </div>
            <span class="precheck-detail" :class="{
              'text-success': onlineDevices.length > 0,
              'text-danger': onlineDevices.length == 0
            }">
              {{$t('smartRouting.mapCenter.pathPlanning.deploymentPrecheck.deviceOnlineDetail', { count: onlineDevices.length })}}
            </span>
          </div>

          <div class="precheck-item">
            <div class="precheck-left">
              <span class="precheck-icon" :class="{
                'icon-pass': resourceCountResult.actionCount + resourceCountResult.voiceCount > 0,
                'icon-fail': resourceCountResult.actionCount + resourceCountResult.voiceCount == 0
              }">
                <i v-if="resourceCountResult.actionCount + resourceCountResult.voiceCount > 0" class="el-icon-circle-check"></i>
                <i v-else class="el-icon-circle-close"></i>
              </span>
              <span class="precheck-label"> {{ $t('smartRouting.mapCenter.pathPlanning.deploymentPrecheck.resourceAvailableLabel') }}  </span>
            </div>
            <span class="precheck-detail" :class="{
              'text-success': resourceCountResult.actionCount + resourceCountResult.voiceCount > 0,
              'text-danger': resourceCountResult.actionCount + resourceCountResult.voiceCount == 0
            }">
              {{$t('smartRouting.mapCenter.pathPlanning.deploymentPrecheck.resourceAvailableDetail', { 
                voiceCount: resourceCountResult.voiceCount, 
                actionCount: resourceCountResult.actionCount 
              })}}
            </span>
          </div>
        </div>

        <div class="precheck-result" :class="{ 'has-warning': precheckWarningCount > 0 }">
          <i class="el-icon-info"></i>
          {{ $t('smartRouting.mapCenter.pathPlanning.deploymentPrecheck.precheckResult') }}
        </div>

        <div class="step-footer">
          <el-button @click="currentStep--" icon="el-icon-arrow-left">
            {{ $t('smartRouting.mapCenter.pathPlanning.deploymentPrecheck.back') }}
          </el-button>
          <!-- :disabled="!canProceed || precheckLoading" -->
          <el-button type="danger" @click="handleNextStep" :loading="precheckLoading" icon="el-icon-arrow-right">
            {{ $t('smartRouting.mapCenter.pathPlanning.deploymentPrecheck.confirm') }}
          </el-button>
        </div>
      </div>

      <!-- ===== 步骤3: 配置下发 ===== -->
      <div v-show="currentStep === 2" class="step-content">
        <div class="progress-title">
          {{ $t('smartRouting.mapCenter.pathPlanning.deliveryProgress.delivering', {
            count: selectedDevices.length,
            routeName: deliverData.name || '',
            strategy: getStrategyLabel()
          }) }}
        </div>

        <div class="progress-summary">
          <div class="summary-title">
            <i class="el-icon-circle-check"></i>
            {{ $t('smartRouting.mapCenter.pathPlanning.deliveryProgress.deliveryComplete') }}
          </div>
          <div class="summary-detail">
            {{ $t('smartRouting.mapCenter.pathPlanning.deliveryProgress.summary', {
              devices: selectedDevices.map(d => d.deviceName).join('、'),
              count: selectedDevices.length,
              strategy: getStrategyLabel()
            }) }}
          </div>
        </div>

        <div class="step-footer">
          <el-button type="danger" @click="handleDeliverDialogClose" icon="el-icon-check">
            {{ $t('smartRouting.mapCenter.pathPlanning.deliveryProgress.finish') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- ========== 新增/编辑路线弹窗 ========== -->
    <el-dialog
      top="5vh"
      v-model="createDialogVisible"
      :title="dialogTitle"
      width="1400px"
      :fullscreen="isFullscreen"
      :close-on-click-modal="false"
      class="route-create-dialog"
      @close="handleDialogClose"
      :show-close="false"
    >
      <template #title>
        <div class="dialog-header">
          <div class="dialog-title">{{ dialogTitle }}</div>
          <div class="dialog-action">
            <el-tooltip
              :content="isFullscreen ? '退出全屏' : '全屏'"
              placement="bottom"
            >
              <i
                :class="isFullscreen ? 'el-icon-rank' : 'el-icon-full-screen'"
                class="fullscreen-btn"
                @click="toggleFullscreen"
              ></i>
            </el-tooltip>
            <i class="el-icon-close icon-btn" @click="handleDialogClose"></i>
          </div>
        </div>
      </template>
      <template #default>
        <RouteCreate
          :isFullscreen="isFullscreen"
          v-if="createDialogVisible"
          ref="routeCreateRef"
          :is-edit="isEditMode"
          :route-code="editRouteCode"
          :route-id="editRouteId"
          :edit-data="editData"
          @save="handleSave"
          @cancel="createDialogVisible = false"
          @success="handleCreateSuccess"
        />
      </template>
    </el-dialog>

    <!-- ========== 详情弹窗 ========== -->
    <!-- fullscreen -->
    <el-dialog
      top="5vh"
      v-model="detailDialogVisible"
      :title="`路径详情 - ${detailRouteId || ''}`"
      width="1400px"
      :fullscreen="isFullscreen"
      :close-on-click-modal="false"
      class="route-detail-dialog"
      @close="handleDetailDialogClose"
      :show-close="false"
    >
      <template #title>
        <div class="dialog-header">
          <div class="dialog-title">{{ `路径详情 - ${detailRouteId || ''}` }}</div>
          <div class="dialog-action">
            <el-tooltip
              :content="isFullscreen ? '退出全屏' : '全屏'"
              placement="bottom"
            >
              <i
                :class="isFullscreen ? 'el-icon-rank' : 'el-icon-full-screen'"
                class="fullscreen-btn"
                @click="toggleFullscreen"
              ></i>
            </el-tooltip>
            <i class="el-icon-close icon-btn" @click="handleDetailDialogClose"></i>
          </div>
        </div>
      </template>
      <template #default>
        <RouteDetail
         :isFullscreen="isFullscreen"
          ref="routeDetailRef"
          :route-id="detailRouteId"
          @close="handleDetailDialogClose"
          @edit="handleEditFromDetail"
          @deliver="handleDeliverFromDetail"
        />
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { reactive, ref, computed, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import { ElMessage, ElMessageBox } from "element-plus";
import Table from "@/components/elp/table";
import {
  reqPathPage,
  reqPathDetail,
  reqPathCreate,
  reqPathUpdate,
  reqPathDelete,
  reqDeployPrecheck,
  reqDeployRoute,
  reqMapList,
  reqDeviceList
} from '@/api/map'
import RouteCreate from "./routeCreate.vue";
import RouteDetail from "./routeDetail.vue";

export default {
  name: "RouteList",
  components: {
    Table,
    RouteCreate,
    RouteDetail
  },
  props: {
    request: {
      type: Function,
      required: true,
    },
  },
  emits: ["add-route", "deliver-route"],
  setup(props, { emit }) {
    const { t } = useI18n();
    const tableRef = ref(null);
    
    // ========== 新增/编辑弹窗相关变量 ==========
    const createDialogVisible = ref(false);
    const isEditMode = ref(false);
    const editRouteId = ref('');
    const editRouteCode = ref('');
    const editData = ref(null);
    const routeCreateRef = ref(null);
    const isFullscreen = ref(false);

    // ========== 详情弹窗相关变量 ==========
    const detailDialogVisible = ref(false);
    const detailRouteId = ref('');
    const routeDetailRef = ref(null);

    const dialogTitle = computed(() => {
      return isEditMode.value 
        ? t('smartRouting.mapCenter.edit')
        : t('smartRouting.mapCenter.pathPlanning.routeManagement.addRoute');
    });

    const mapList = ref([])

    // ========== Table 参数 ==========
    const tableParams = reactive([
      {
        key: "pathCode",
        value: "",
        label: t("smartRouting.mapCenter.pathPlanning.routeId"),
        type: "input",
        clearable: true,
      },
      {
        key: "pathName",
        value: "",
        label: t("smartRouting.mapCenter.pathPlanning.routeName"),
        type: "input",
        clearable: true,
      },
      {
        type: "Select",
        key: "mapCode",
        value: '',
        label: '关联地图',
        options: {
          data: mapList,
          label: "name",
          value: "code"
        }
      },
    ]);
    // ========== 1. 新增路线 ==========
    const handleAddRoute = () => {
      isEditMode.value = false;
      editRouteId.value = '';
      editRouteCode.value = '';
      editData.value = null;
      createDialogVisible.value = true;
    };

    // ========== 2. 路线详情 ==========
    const openDetailDialog = async (row) => {
      detailRouteId.value = row.id;
      detailDialogVisible.value = true;
    };

    // ========== 3. 从详情页编辑 ==========
    const handleEditFromDetail = (data) => {
      detailDialogVisible.value = false;
      isEditMode.value = true;
      editRouteId.value = data.id;
      editRouteCode.value = data.code;
      editData.value = data;
      createDialogVisible.value = true;
    };

    // ========== 4. 从详情页下发 ==========
    const handleDeliverFromDetail = (data) => {
      detailDialogVisible.value = false;
      const row = {
        id: data.id || data.routeId,
        routeId: data.routeId,
        routeName: data.routeName,
        associateMap: data.associateMap,
        pathType: data.pathType,
        version: data.version,
        mapVersion: data.mapVersion,
      };
      openDeliverDialog(row);
    };

    // ========== 6. 编辑路线（列表页） ==========
    const handleEdit = async (row) => {
      console.log('编辑数据:', row);
      try {
        // 获取完整数据用于编辑
        const res = await reqPathDetail(row.id);
        const data = res.data || res;
        isEditMode.value = true;
        editRouteId.value = row.id;
        editRouteCode.value = row.code;
        editData.value = data;
        createDialogVisible.value = true;
      } catch (error) {
        console.error('获取编辑数据失败:', error);
        ElMessage.error(t('error.getDetailFailed'));
      }
    };

    // ========== 7. 删除路线 ==========
    const handleDelete = async (row) => {
      try {
        await ElMessageBox.confirm(
          t('smartRouting.mapCenter.pathPlanning.deleteConfirm', {
            name: row.name
          }),
          t('smartRouting.mapCenter.pathPlanning.deleteTitle'),
          {
            confirmButtonText: t('smartRouting.mapCenter.pathPlanning.routeManagement.confirm'),
            cancelButtonText: t('smartRouting.mapCenter.pathPlanning.cancel'),
            type: 'warning'
          }
        )
        const res = await reqPathDelete(row.code)
          ElMessage.success(t('smartRouting.mapCenter.pathPlanning.deleteSuccess'))
          tableRef.value?.search()
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除路线失败:', error)
          ElMessage.error(t('smartRouting.mapCenter.pathPlanning.deleteFailed'))
        }
      }
    }

    // ========== 8. 保存回调 ==========
    const handleSave = async (formData) => {
      try {
        let res;
        if (isEditMode.value) {
          // 编辑模式
          res = await reqPathUpdate({
            id: editRouteId.value,
            ...formData
          });
        } else {
          // 新建模式
          res = await reqPathCreate(formData);
        }

        ElMessage.success(
          isEditMode.value 
            ? t('smartRouting.mapCenter.pathPlanning.updateSuccess')
            : t('smartRouting.mapCenter.pathPlanning.createSuccess')
        );
        createDialogVisible.value = false;
        tableRef.value?.search();
      } catch (error) {
        console.error('保存失败:', error);
        ElMessage.error(t('error.saveFailed'));
      }
    };

    // ========== 9. 创建成功回调 ==========
    const handleCreateSuccess = () => {
      createDialogVisible.value = false;
      tableRef.value?.search();
    };

    // ========== 10. 弹窗关闭回调 ==========
    const handleDialogClose = () => {
      createDialogVisible.value = false;
      isEditMode.value = false;
      editRouteId.value = '';
      editData.value = null;
      isFullscreen.value = false
    };

    // ========== 11. 详情弹窗关闭 ==========
    const handleDetailDialogClose = () => {
      detailDialogVisible.value = false;
      detailRouteId.value = '';
      isFullscreen.value = false
    };

    // ============================================================
    // ========== 下发三步向导 ==========
    // ============================================================
    const deliverDialogVisible = ref(false);
    const currentStep = ref(0);
    const confirmOverwrite = ref(false);
    const deliveryComplete = ref(false);
    const step1Loading = ref(false);
    const precheckLoading = ref(false);

    const deliverData = reactive({
      id: '',
      routeId: '',
      name: '',
      associateMap: '',
      pathType: '',
      strategy: 'FULL',
      oldVersion: 'v1.0',
      newVersion: 'v2.0',
      mapVersion: 'v1.0',
      resolution: '0.05',
      forbiddenCount: 0,
      poiCount: 0,
      pointCount: 0,
      voiceCount: 0,
      expressionCount: 0,
      motionCount: 0,
      narrationCount: 0,
      imageCount: 0,
    });

    const deviceList = ref([]);
    const selectedDevices = ref([]);
    const excludedCount = ref(0);
    const onlineDevices = ref([])
    const resourceCountResult = ref([])

    const getStrategyLabel = () => {
      const map = {
        FULL: t("smartRouting.mapCenter.pathPlanning.routePackageDelivery.strategyFull"),
        GRAY: t("smartRouting.mapCenter.pathPlanning.routePackageDelivery.strategyGray"),
        INCR: t("smartRouting.mapCenter.pathPlanning.routePackageDelivery.strategyIncremental"),
      };
      return map[deliverData.strategy] || deliverData.strategy;
    };

    // const precheckWarningCount = computed(() => {
    //   return precheckItems.value.filter(item => item.warning).length;
    // });

    // ===== 打开下发弹窗 - 获取设备列表 =====
    const openDeliverDialog = async (row) => {
      console.log('打开下发弹窗 - 获取设备列表', row);
      // 设置路线数据
      deliverData.id = row.id
      deliverData.routeId = row.id
      deliverData.resourceCode = row.code
      deliverData.name = row.name
      deliverData.associateMap = row.associateMap
      deliverData.pathType = row.pathType
      deliverData.strategy = 'FULL'
      deliverData.oldVersion = row.version 
      deliverData.newVersion = row.newVersion
      deliverData.mapVersion = row.mapVersion
      deliverData.resolution = row.resolution
      deliverData.forbiddenCount = row.forbiddenCount || 0
      deliverData.poiCount = row.poiCount || 0
      deliverData.pointCount = row.pointCount || 0
      deliverData.voiceCount = row.voiceCount || 0
      deliverData.expressionCount = row.expressionCount || 0
      deliverData.motionCount = row.motionCount || 0
      deliverData.narrationCount = row.narrationCount || 0
      deliverData.imageCount = row.imageCount || 0

      currentStep.value = 0
      confirmOverwrite.value = false
      deliveryComplete.value = false
      selectedDevices.value = []

      deliverDialogVisible.value = true

      // 获取设备列表 - 调用接口
      try {
        const res = await reqDeviceList({ })
        const data = res
        deviceList.value = res || []
        excludedCount.value = data.excludedCount || 0

        // 默认选中已关联的设备
        if (data.defaultSelected) {
          selectedDevices.value = deviceList.value.filter(d =>
            data.defaultSelected.includes(d.deviceName)
          )
        }
      } catch (error) {
        console.error('获取设备列表失败:', error)
        ElMessage.error(t('error.getDevicesFailed'))
      }
    };

    const handleSelectionChange = (selection) => {
      selectedDevices.value = selection
    }

    const handleDeliverDialogClose = () => {
      deliverDialogVisible.value = false;
      currentStep.value = 0;
      confirmOverwrite.value = false;
      deliveryComplete.value = false;
    };

    // ===== 下一步 - 步骤1 → 步骤2 调用预检接口 =====
    const handleNextStep = async () => {
      if (currentStep.value === 0) {
        step1Loading.value = true
        try {
          // 调用预检接口
          const res = await reqDeployPrecheck({
            resourceCode: deliverData.resourceCode,
            targetDevices: selectedDevices.value.map(d => d.deviceCode),
            resourceType: 'ROUTE'
          })
          onlineDevices.value = res.onlineDevices
          resourceCountResult.value = res.resourceCountResult
          currentStep.value = 1
        } catch (error) {
          console.error('预检失败:', error)
          ElMessage.error(t('error.precheckFailed'))
        } finally {
          step1Loading.value = false
        }
      } else if (currentStep.value === 1) {
        // 调用下发接口
        await handleDeploy()
      }
    };

    // ===== 执行下发 =====
    const handleDeploy = async () => {
      precheckLoading.value = true
      try {
        const res = await reqDeployRoute({
          routeCode: deliverData.resourceCode,
          targetDevices: onlineDevices.value,
          strategy: 'FULL'
        })
        const data = res.data || res
        currentStep.value = 2
        // 刷新表格
        // tableRef.value?.search()
      } catch (error) {
        console.error('下发失败:', error)
        ElMessage.error(t('error.deployFailed'))
      } finally {
        precheckLoading.value = false
      }
    };

    const handleDeliver = (row) => {
      emit("deliver-route", row);
    };

    const getData = async(params) => {
      const query = {
        pageNum: params.page,
        pageSize: params.size,
      }
      if (params.dateRange?.length) {
        query.startDate = params.dateRange[0]
        query.endDate = params.dateRange[1]
      } else {
        query.startDate = undefined
        query.endDate = undefined
      }

      return await reqPathPage(Object.assign(query, params))
    };

    const getMapPage = async(params) => {
      const query = {
        keyword: '',
        limit: 100,
      }
      const res = await reqMapList(query)
      mapList.value = res
    };

    getMapPage()
    const toggleFullscreen = () => {
      isFullscreen.value = !isFullscreen.value
    };

    return {
      // Table 相关
      tableRef,
      tableParams,
      // 新增/编辑相关
      createDialogVisible,
      isEditMode,
      editRouteId,
      editRouteCode,
      editData,
      routeCreateRef,
      isFullscreen,
      dialogTitle,
      // 详情相关
      detailDialogVisible,
      detailRouteId,
      routeDetailRef,
 
      
      // 下发相关
      deliverDialogVisible,
      currentStep,
      deliverData,
      deviceList,
      selectedDevices,
      excludedCount,
      confirmOverwrite,
      deliveryComplete,
      step1Loading,
      precheckLoading,
      resourceCountResult,
      onlineDevices,
      getData,
      handleAddRoute,
      handleSave,
      handleCreateSuccess,
      handleDialogClose,
      openDetailDialog,
      handleDetailDialogClose,
      handleEditFromDetail,
      handleDeliverFromDetail,
      // 删除相关
      handleDelete,
      // 编辑相关
      handleEdit,
      getStrategyLabel,
      openDeliverDialog,
      handleDeliverDialogClose,
      handleNextStep,
      handleSelectionChange,
      handleDeliver,
      toggleFullscreen
    };
  },
};
</script>

<style scoped>
.route-list-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.dialog-title {
  flex: 1;
  max-height: 300px;
  overflow: auto;
  margin-right: 8px;
  text-align: left;
}

.dialog-action {
  flex-shrink: 0;
}

.fullscreen-btn {
  font-size: 20px;
  cursor: pointer;
  color: #606266;
  transition: color 0.2s;
  margin-right: 24px;
}

.fullscreen-btn:hover {
  color: #409eff;
}

.icon-btn{
  cursor: pointer;
}

/* ========== 下发向导弹窗样式 ========== */
.deliver-dialog :deep(.el-dialog__header) {
  border-bottom: 1px solid #ebeef5;
  padding: 18px 24px;
  background: #fafbfc;
  border-radius: 8px 8px 0 0;
}
.deliver-dialog :deep(.el-dialog__title) {
  font-size: 18px;
  font-weight: 600;
  color: #1d2129;
}
.deliver-dialog :deep(.el-dialog__body) {
  padding: 24px 28px;
  max-height: 68vh;
  overflow-y: auto;
}
.deliver-dialog :deep(.el-dialog__footer) {
  border-top: 1px solid #ebeef5;
  padding: 16px 24px;
}

.deliver-steps {
  margin-bottom: 28px;
}
.deliver-steps :deep(.el-step__title) {
  font-weight: 500;
  font-size: 14px;
}

/* .step-content {
  min-height: 280px;
} */

.step-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 18px;
  border-top: 1px solid #ebeef5;
}

/* 向导提示 */
.step-hint {
  font-size: 14px;
  color: #606266;
  background: #f5f7fa;
  padding: 14px 18px;
  border-radius: 8px;
  margin-bottom: 20px;
  line-height: 1.6;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  border-left: 3px solid #409eff;
}
.step-hint .el-icon-info {
  font-size: 18px;
  color: #409eff;
  margin-top: 1px;
  flex-shrink: 0;
}

/* 策略选择 - 下拉框 */
.strategy-section {
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  /* padding: 12px 16px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e9edf2; */
}
.strategy-label {
  font-weight: 600;
  color: #1d2129;
  font-size: 14px;
  white-space: nowrap;
  flex-shrink: 0;
}
.strategy-select {
  width: 130px;
  flex-shrink: 0;
}
.strategy-hint {
  font-size: 12px;
  color: #86909c;
  margin-left: 4px;
  background: #ffffff;
  padding: 2px 12px;
  border-radius: 12px;
  border: 1px solid #e9edf2;
}

.device-count {
  font-weight: 400;
  color: #909399;
  font-size: 12px;
}

/* 设备列表 */
.device-section {
  margin-bottom: 18px;
}
.device-header {
  font-size: 13px;
  color: #606266;
  margin-bottom: 10px;
  font-weight: 500;
}
.device-title {
  color: #1d2129;
}

.device-table :deep(.el-table__header th) {
  background: #f7f9fb;
  color: #1d2129;
  font-weight: 500;
}
.device-table :deep(.el-table__body td) {
  font-size: 13px;
}

.status-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 6px;
}
.status-dot.online {
  background: #67c23a;
}
.status-dot.offline {
  background: #f56c6c;
}

.map-status {
  display: flex;
  align-items: center;
  gap: 6px;
}
.map-version {
  font-family: 'Courier New', monospace;
  font-weight: 500;
}
.occupied-tag {
  margin-left: 4px;
}
.text-success {
  color: #67c23a;
}
.text-danger {
  color: #f56c6c;
}
.text-muted {
  color: #c0c4cc;
}
.text-warning {
  color: #e6a23c;
}

/* 路径大包内容 */
.package-content {
  background: #f8fafc;
  border: 1px solid #e9edf2;
  border-radius: 8px;
  padding: 14px 18px;
}
.package-title {
  font-weight: 600;
  color: #1d2129;
  font-size: 14px;
  margin-bottom: 10px;
}
.package-items {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.package-item {
  font-size: 13px;
  color: #4e5969;
  line-height: 1.8;
  padding: 2px 0;
}
.package-badge {
  display: inline-block;
  font-weight: 600;
  color: #409eff;
  margin-right: 4px;
}
.package-version {
  color: #409eff;
  margin-left: 8px;
  font-size: 12px;
}
.package-tag {
  background: #e4e7ed;
  color: #86909c;
  padding: 0 10px;
  border-radius: 4px;
  font-size: 12px;
  margin-left: 8px;
}

/* 预检 */
.precheck-title {
  font-weight: 600;
  color: #1d2129;
  font-size: 15px;
  background: #ecf5ff;
  border-radius: 4px;
  padding: 10px 14px;
  /* font-size: 13px;
  color: #303133; */
  line-height: 1.6;
  margin-bottom: 16px;
  text-align: left;

  .file-name {
    color: #409eff;
    font-weight: 500;
  }
}
.precheck-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}
.precheck-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background: #f8fafc;
  border-radius: 6px;
  border: 1px solid #f0f2f5;
  transition: all 0.2s;
}
.precheck-item:hover {
  border-color: #d9dde4;
}
.precheck-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.precheck-icon {
  font-size: 18px;
  display: flex;
  align-items: center;
}
.precheck-icon .el-icon-circle-check {
  color: #67c23a;
}
.precheck-icon .el-icon-warning {
  color: #e6a23c;
}
.precheck-icon .el-icon-circle-close {
  color: #f56c6c;
}
.precheck-label {
  font-size: 13px;
  color: #1d2129;
  font-weight: 500;
}
.precheck-detail {
  font-size: 13px;
  color: #4e5969;
}

/* 地图版本比对 */
.version-compare {
  margin: 12px 0 16px;
  padding: 14px 16px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e9edf2;
}
.compare-title {
  font-weight: 500;
  color: #1d2129;
  font-size: 13px;
  margin-bottom: 10px;
}
.compare-table :deep(.el-table__header th) {
  background: #f7f9fb;
  font-weight: 500;
}
.compare-table :deep(.el-table__body td) {
  font-size: 13px;
}

/* 确认覆盖 */
.confirm-section {
  margin: 12px 0;
  padding: 14px 18px;
  background: #fdf6ec;
  border-radius: 8px;
  border: 1px solid #fae6d0;
}
.confirm-section :deep(.el-checkbox__label) {
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
}

/* 预检结果 */
.precheck-result {
  padding: 12px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f0f9eb;
  color: #67c23a;
  border: 1px solid #d4edda;
}
.precheck-result .el-icon-info {
  font-size: 18px;
}
.precheck-result.has-warning {
  background: #fdf6ec;
  color: #e6a23c;
  border-color: #fae6d0;
}

/* 进度 */
.progress-title {
  font-weight: 600;
  color: #1d2129;
  font-size: 15px;
  margin-bottom: 18px;
  text-align: left;

  background: #ecf5ff;
  border-radius: 4px;
  padding: 10px 14px;
  font-size: 13px;
  color: #303133;
  line-height: 1.6;
  margin-bottom: 16px;
}
.progress-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 18px;
}
.progress-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: #f8fafc;
  border-radius: 6px;
  border: 1px solid #f0f2f5;
}
.progress-label {
  font-size: 13px;
  color: #1d2129;
}
.progress-status {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
}
.progress-status .el-icon-circle-check {
  font-size: 16px;
}
.progress-status .el-icon-loading {
  font-size: 16px;
  animation: rotating 1.5s linear infinite;
}
.progress-status.status-done {
  color: #67c23a;
}
.progress-status.status-pending {
  color: #e6a23c;
}

@keyframes rotating {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 进度汇总 */
.progress-summary {
  background: #f0f9eb;
  border-radius: 8px;
  padding: 14px 18px;
  margin-bottom: 14px;
  border: 1px solid #d4edda;
}
.summary-title {
  font-weight: 600;
  color: #67c23a;
  font-size: 14px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.summary-title .el-icon-circle-check {
  font-size: 18px;
}
.summary-detail {
  font-size: 13px;
  color: #4e5969;
  line-height: 1.6;
  text-align: left;
  margin-top: 8px;
}

/* 下载 */
.download-section {
  padding: 14px 18px;
  background: #f5f7fa;
  border-radius: 8px;
  border: 1px solid #e9edf2;
}
.download-section :deep(.el-checkbox__label) {
  font-size: 13px;
  color: #1d2129;
}
.download-file {
  margin-top: 6px;
  padding-left: 28px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.download-file .el-link {
  font-size: 13px;
}
.download-file .el-link .el-icon-document {
  font-size: 14px;
}
.download-file .el-button {
  font-size: 12px;
  color: #86909c;
}
.download-file .el-button .el-icon-refresh {
  font-size: 12px;
}

/* ========== 新增/编辑弹窗样式 ========== */
.route-create-dialog :deep(.el-dialog__header) {
  border-bottom: 1px solid #ebeef5;
  padding: 18px 24px;
  background: #fafbfc;
}
.route-create-dialog :deep(.el-dialog__title) {
  font-size: 18px;
  font-weight: 600;
  color: #1d2129;
}
.route-create-dialog :deep(.el-dialog__body) {
  padding: 0;
  height: calc(100vh - 120px);
  overflow: hidden;
}

/* ========== 详情弹窗样式 ========== */
.route-detail-dialog :deep(.el-dialog__header) {
  border-bottom: 1px solid #ebeef5;
  padding: 18px 24px;
  background: #fafbfc;
}
.route-detail-dialog :deep(.el-dialog__title) {
  font-size: 18px;
  font-weight: 600;
  color: #1d2129;
}
.route-detail-dialog :deep(.el-dialog__body) {
  padding: 0;
  height: calc(100vh - 120px);
  overflow: hidden;
}
</style>